import classNames from "classnames";
import React, { PropsWithChildren } from "react";
import { Controller, Control, FieldPath, FieldValues } from "react-hook-form";
import { CustomInput, CustomInputProps } from "Components/ReactstrapSlim";

export interface CheckboxProps extends Partial<CustomInputProps> {
   id: CustomInputProps["id"]
}

export const Checkbox: React.FC<CheckboxProps> = ({ className = "", type, ...rest }) => {
   return (
      <CustomInput type="checkbox" {...rest} className={className} />
   );
}

export interface CheckboxControlledProps<T extends FieldValues> extends Partial<CustomInputProps> {
   control: Control<T>,
   name: FieldPath<T>,
}

export const CheckboxControlled = <T extends FieldValues,>({ control, name, className = "", type, ...rest }: PropsWithChildren<CheckboxControlledProps<T>>) => (
   <Controller
      name={name}
      control={control}
      render={({
         field,
         fieldState: { error }
      }) => {
         const { name, value, onChange, onBlur } = field;
         const mergedClasses = classNames(
            className,
            !!error && "checkbox--invalid"
         );
         return <>
            <Checkbox id={name} name={name} {...rest} className={mergedClasses} checked={value ?? false} onChange={onChange} onBlur={onBlur} />
            {error?.message && <div className="lbl1 text-danger">{error.message}</div>}
         </>
      }}
   />
);
